import{getBaseUrl as n}from"../utils/get-base-url";async function l(t){const e=`${n(t)}/global`;return fetch(e,{signal:t.abortSignal}).then(o=>o.json())}export{l as getGlobalSettings};
